/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckOfferStatusEnum } from './deck-offer-status-enum';

/**
 * Offer serializer in deck
 */
export interface DeckOffer {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly company_url: string | null;
  readonly banner: string;
  readonly shares: number;
  readonly added_by_id: string;
  readonly status: DeckOfferStatusEnum;
  readonly subscribed: boolean;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly modified_date: string;
  readonly url: string | null;
}
export namespace DeckOffer {}
